import { AppConstants, Types } from '../constants';

const { REACT_APP_SEARCH_BASE_URL } = process.env;

export const getFilterLabelInformation = (id) => { // eslint-disable-line
  if (id === 'name') {
    return {
      label: 'Name',
      placeholder: 'First, last, or preferred name',
    };
  } else if (id === 'dob') {
    return {
      label: 'DOB',
      placeholder: 'Birthdate (MM/DD/YYYY)',
    };
  } else if (id === 'phone') {
    return {
      label: 'Phone',
      placeholder: AppConstants.PHONE_PLACEHOLDER,
    };
  } else if (id === 'id') {
    return {
      label: 'ID',
      placeholder: 'Patient ID',
    };
  } else if (id === 'tags') {
    return {
      label: 'Tags',
      placeholder: 'Tag name',
    };
  }

  return {
    label: 'Email',
    placeholder: 'Email address',
  };
};

export const filterContactParams = { filterParams: ['name', 'dob', 'phone', 'id', 'email', 'tags'] };
export const filterMemberParams = { filterParams: ['name', 'email', 'tags'] };

const searchScopeMapping = {
  members: [Types.TYPE_MEMBER],
  nonMembers: [Types.TYPE_PATIENT, Types.TYPE_UNKNOWN, Types.TYPE_USER_OTHER],
  patientsAndOthers: [Types.TYPE_PATIENT, Types.TYPE_USER_OTHER],
};

export function getSearchUrl(payload) {
  const { search, scope, type = 'name', excludeCurrentUser, idsToExclude } = payload;
  const encodedSearch = encodeURIComponent(search);
  const searchScope = searchScopeMapping[scope];
  let url = `${REACT_APP_SEARCH_BASE_URL}/users/search?q=${encodedSearch}`;

  if (searchScope) url += `&scope=${searchScope}`;
  if (type) url += `&type=${type}`;
  if (excludeCurrentUser) url += `&excludeCurrentUser=${excludeCurrentUser}`;
  if (idsToExclude) url += `&idsToExclude=${idsToExclude}`;

  return url;
}
